<template>
  <div class="filter-group">
    <button
      v-for="opt in options"
      :key="opt.value"
      class="filter-btn"
      :class="{ 'filter-btn--active': value === opt.value }"
      :style="value === opt.value ? activeStyle(opt) : {}"
      @click="$emit('change', opt.value)"
    >
      <span
        v-if="type === 'site' && opt.value !== 'all'"
        class="filter-dot"
        :style="{ background: dotColor(opt) }"
      ></span>
      {{ opt.label }}
    </button>
  </div>
</template>

<script>
const SITE_COLORS = {
  'Construct':  { bg: '#FFF4E6', color: '#C27C0E', dot: '#F59E0B' },
  'Kismetál': { bg: '#E8F0FF', color: '#2B55C5', dot: '#4B7BF5' },
};

const STATUS_ACTIVE_COLORS = {
    all:      '#1a1a2e',
    active:   '#1A9E5C',
    inactive: '#E05252',
    1:   '#1A9E5C',
    0: '#E05252',
};

export default {
  name: 'FilterButtonGroup',
  props: {
    options: { type: Array,  required: true },
    value:   { type: String, required: true },
    type:    { type: String, default: 'status' },
  },
  methods: {
    activeStyle(opt) {
      if (this.type === 'site' && opt.value !== 'all') {
        const c = SITE_COLORS[opt.value];
        return c ? { background: c.color, color: '#fff' } : { background: '#1a1a2e', color: '#fff' };
      }
      return { background: STATUS_ACTIVE_COLORS[opt.value] || '#1a1a2e', color: '#fff' };
    },
    dotColor(opt) {
      const c = SITE_COLORS[opt.value];
      if (!c) return '#9DA5C0';
      return this.value === opt.value ? 'rgba(255,255,255,0.6)' : c.dot;
    },
  },
};
</script>

<style scoped>
.filter-group {
  display: flex;
  background: #F0F2F7;
  border-radius: 12px;
  padding: 3px;
  gap: 2px;
}
.filter-btn {
  cursor: pointer;
  border: none;
  background: transparent;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  color: #7B82A0;
  border-radius: 9px;
  padding: 7px 13px;
  display: flex;
  align-items: center;
  gap: 5px;
  transition: background .15s, color .15s;
  white-space: nowrap;
}
.filter-btn:hover:not(.filter-btn--active) {
  background: #e4e7f0;
  color: #4A5068;
}
.filter-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
}
</style>